import React from "react";
import "../../css/pp-sect3.css";
import PopSubj from "../PopSubj.js";

const Sect3 = () => {
  return (
    <section id="pp-sect3">
      <div>
        <article>
          <h2>Popular subjects</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
        </article>
        <div>
          <PopSubj />
        </div>
        <button>View all subjects</button>
      </div>
    </section>
  );
};

export default Sect3;
